import Vue from "vue";
import store from "../store";

const WEBSOCKET_ERRORS = {
  1000: "Normal closure",
  1001: "An endpoint is going away",
  1002: "An endpoint is terminating the connection due to a protocol error",
  1003: "An endpoint is terminating the connection because it has received a type of data it cannot accept",
  1004: "Reserved. The specific meaning might be defined in the future",
  1005: "No status code was actually present",
  1006: "The connection was closed abnormally",
  1007: "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).",
  1008: "An endpoint is terminating the connection because it has received a message that \"violates its policy\". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.",
  1009: "An endpoint is terminating the connection because it has received a message that is too big for it to process.",
  1010: "An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake.",
  1011: "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.",
  1015: "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).",
  9999: "Unknown reason"
};

export default class ServerEvents extends Vue {
  constructor() {
    super({
      data: {
        websocket: null
      },
      methods: {
        getWebsocketUrl() {
          const token = store.getters.token ? store.getters.token.substr(6) : ""; // Basic ...
          const WS_URL = store.getters.wsPath;
          return `${WS_URL}?access_token=${token}`;
        },
        async connect() {
          return new Promise(resolve => {
            this.websocket = new WebSocket(this.getWebsocketUrl());
            this.websocket.onmessage = e => this.$emit("socket-message", JSON.parse(e.data));
            this.websocket.onopen = e => {
              resolve(this);
              this.$emit("socket-open", e);
            };
            this.websocket.onerror = () => {
              // this.$emit("socket-error", e);
            };
            this.websocket.onclose = e => {
              if (e.code === 1000) {
                this.$emit("socket-close");
              } else {
                const err = [
                  "Ошибка вебсокета:",
                  (`${e.code}` in WEBSOCKET_ERRORS)? WEBSOCKET_ERRORS[`${e.code}`]: WEBSOCKET_ERRORS[`9999`],
                  e.reason
                ];
                this.$emit("socket-error", new Error(err.join(" ")));
              }
              // reject();
              resolve();
            };
          });
        },
        disconnect() {
          try {
            this.websocket.close();
          } catch(ignore) {
            // eslint-disable-next-line
          }
        },
        sendMessage(msg) {
          // eslint-disable-next-line
          console.debug("events::sendMessage", msg);
          this.websocket.send(JSON.stringify(msg));
          // eslint-disable-next-line
          console.debug("events::sendMessage SENT");
        }
      },
      destroyed() {
        this.disconnect();
      }
    });
  }
}
